/** Amplify が投げるエラーオブジェクトから name を取り出す */
function amplifyErrorName(err: unknown): string {
  if (err && typeof err === 'object' && 'name' in err) {
    const n = (err as { name: unknown }).name;
    if (typeof n === 'string') return n;
  }
  return '';
}

/** Hosted UI が ?error= で返した内容を画面向けに短くする */
export function formatHostedUiCallbackQueryError(errorCode: string, errorDescription: string): string {
  const t = `${errorCode} ${errorDescription}`.toLowerCase();
  if (t.includes('invalid_client') || t.includes('401')) {
    return 'Google 連携の設定に問題がある可能性があります。管理者にお問い合わせください。';
  }
  if (errorCode === 'access_denied') {
    return 'ログインがキャンセルされたか、同意が得られませんでした。';
  }
  return 'サインインできませんでした。';
}

/** リダイレクト開始時の例外を画面向けに短くする */
export function formatAuthRedirectError(err: unknown): string {
  switch (amplifyErrorName(err)) {
    case 'OAuthNotConfigureException':
    case 'AuthUserPoolException':
      return '認証の設定が正しくありません。管理者にお問い合わせください。';
    case 'InvalidOriginException':
      return 'この URL ではログインを開始できません。アドレスを確認するか、管理者にお問い合わせください。';
    case 'InvalidRedirectException':
      return 'コールバック URL の設定が一致していません。管理者にお問い合わせください。';
    case 'UserAlreadyAuthenticatedException':
      return 'すでにログイン済みです。ログアウトしてからお試しください。';
    default:
      return 'ログインを開始できませんでした。';
  }
}

/** メール＋パスワードの signIn / confirmSignIn を画面向けに短くする */
export function formatPasswordSignInError(err: unknown): string {
  const name = amplifyErrorName(err);
  switch (name) {
    case 'NotAuthorizedException':
      return 'メールアドレスまたはパスワードが正しくありません。';
    case 'PasswordResetRequiredException':
      return 'パスワードの再設定が必要です。管理者にお問い合わせください。';
    case 'UserNotConfirmedException':
      return 'アカウントが未確認です。管理者にお問い合わせください。';
    case 'InvalidPasswordException':
      return 'パスワードポリシーを満たしていません（8文字以上・大文字・小文字・数字・記号）。';
    case 'LimitExceededException':
      return '試行回数が多すぎます。しばらくしてからお試しください。';
    case 'InvalidParameterException':
      return '入力内容を確認してください。';
    default:
      return 'サインインに失敗しました。';
  }
}
